import { Modal, Box, IconButton, Divider, Tooltip } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import React from "react";
import { useState } from "react";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import "../Styles/AdminListings.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  minWidth:"60%",
  minHeight:"50%",
  maxHeight:"50%",
  padding: "12px 15px !important",
  bgcolor: "background.paper",
  boxShadow: 24,
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: "2px",
  borderRadius:"10px",
  //overflow: "auto"
};

function AchFileContentModal(props) {
  
  const [copyStatus, setCopyStatus]= useState('Copy');
  const [open, setOpen]= useState(false);
  const [disableIcon, setDisableIcon] = useState(false);

  const handleCopyBtnClick = async() => {
      try{
        setDisableIcon(true);
          await navigator.clipboard.writeText(props.fileContent);
          setOpen(true);
          setCopyStatus('Copied!');
          setTimeout(()=>{           
            setOpen(false);
            }, 1000);
          setDisableIcon(false);
          setTimeout(()=>
             setCopyStatus(""), 1300);
         }
          catch(err) { 
            console.error("Failed to copy content");
            setCopyStatus("Error");
        }
      };
    
      const handleClose = () => {
        setTimeout(()=>setOpen(false),2000);
      };
    
      const handleOpen = () => {
        if(copyStatus===""){
          setCopyStatus('Copy');
        }
        setOpen(true);
        
        setTimeout(()=>{
          setOpen(false);
          if(copyStatus===""){
            setCopyStatus('Copy');
          }},1600);
      };

  return (
    <Modal open={true} onClose={props.onClose}>
      <>
        <Box sx={style}>
        <Box sx={{
            width:"100%",
            display: "flex",
            flexDirection: "row",
           // float: "right",
            justifyContent: "center",
            alignContent:"center",
            padding: "4px"
        }}>
          <Box sx={{
            width:"100%",
            display: "flex",
            flexDirection: "row",
            float: "left",
            justifyContent: "left",
            alignContent:"left",
            fontSize: "17px",
            color: "#002d82",
            fontWeight: 600
          }}
            >
              {props.fileName}
          </Box>
        <Box
            sx={{
            display: "flex",
            flexDirection: "row",
            float: "right",
            justifyContent: "right",
            alignContent:"right"
          }}>
           <IconButton
              aria-label="close"
              onClick={props.onClose}
              sx={{
                //position: "absolute",
                //right: 12,
                //top: 10,
                width: "25px",
                height: "25px",
                color: "white",
                backgroundColor: "red",
                padding: "2px",
                boxShadow: "none",
              }}
            >
              <CloseIcon />
            </IconButton>
        </Box>
        </Box>
        
        <Divider
                variant="fullwidth"
                sx={{ backgroundColor: "#dfe3e8" }}
                ></Divider> 

            <Box
            sx={{
                width:"100%",
                minHeight:"260px",
                display: "flex",
                flexDirection: "column",
               // float: "right",
                justifyContent: "center",
                alignContent:"center",
                padding: "4px",
                border: "2px solid #dfe3e8",
                columnGap:"5px"
                }}>
                <Box
                sx={{
                width:"100%",
                height:"10px", 
                minHeight:"30px",
                float: "right",
                justifyContent: "right",
                alignContent:"right"
                }}>
                <Tooltip open={open} onOpen={handleOpen} title={copyStatus}>
                <IconButton
                    aria-label="close"
                    disabled={disableIcon}
                    onClick={() => handleCopyBtnClick()}
                    sx={{
                      position: "absolute",
                      right: 14,
                      top: 55,
                      //color: "white",
                      padding: "2px",
                      boxShadow: "none",
                    }}
                  >
                    <ContentCopyIcon />
                  </IconButton>
                  </Tooltip>
                  </Box> 
                 
                  <Box sx={{
                    padding: "4px",
                    fontSize:"12px",
                    overflowX: "auto"
                  }}>
                    <pre>{props.fileContent}</pre>
                  </Box>
            </Box>
        </Box>
      </>
    </Modal>
  );
}


export default AchFileContentModal;
